import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { CategoryService } from "src/app/services/category.service";
import { EntityService } from "src/app/services/entity.service";
import { SharedService } from "src/app/services/sharedService";
import { MultiselectAutocompleteComponent } from "../../../../multiselect-autocomplete/multiselect-autocomplete.component";
import { MatSelectChange } from "@angular/material/select";
import { PropertyTaxService } from "src/app/services/propertyTax.service";

@Component({
  selector: 'app-search-property-tax',
  templateUrl: './search-property-tax.component.html',
  styleUrls: ['./search-property-tax.component.css']
})
export class SearchPropertyTaxComponent implements OnInit, OnDestroy {
  @ViewChild('municipalitySelect', { static: false }) municipalitySelect: MultiselectAutocompleteComponent;
  @ViewChild('districtSelect', { static: false }) districtSelect: MultiselectAutocompleteComponent;
  @ViewChild('ilotSelect', { static: false }) ilotSelect: MultiselectAutocompleteComponent;
  @ViewChild('lotSelect', { static: false }) lotSelect: MultiselectAutocompleteComponent;
  
  @Output() onFilter = new EventEmitter<any>();
  @Output() onReset = new EventEmitter<any>();
  
  @Input() extraFields: any;
  @Input() singleMunicipality: any;
  @Input() type: string; 

  filterData = {
    municipality: null,
    district: null,
    ilot: null,
    lot: null
  };

  queryFilter = {};
  filterFields = ["municipality", "district", "ilot", "lot"];
  panelOpenState = true;

  municipalities;
  municipality;
  districts;
  district;
  ilots;
  ilot;
  lots;
  lot;
  ilotId

  municipalityChangeSubscription: any;

  constructor(
    public categoryService: CategoryService,
    public entityService: EntityService,
    public sharedService: SharedService,
    public propertyTaxService: PropertyTaxService
  ) {}

  ngOnInit(): void {
    this.categoryService.getList('municipality').subscribe((mun) => {
      this.municipalities = mun;
      this.filterData['municipality'] = mun.map((m) => ({ id: m.id, name: m.name }));
      this.populateDropdowns();

      const storedMunicipalityId = localStorage.getItem('municipality');
      if (storedMunicipalityId && !this.singleMunicipality) {
        const selected = this.filterData['municipality'].find(m => m.id === storedMunicipalityId);
        if (selected && this.municipalitySelect) {
          this.municipalitySelect.resetAll();
          this.municipalitySelect.setSelectedData([selected]);
          this.selectChange({ data: [selected] }, 'municipality');
        }
      }
    });

    this.municipalityChangeSubscription = this.sharedService.changeMunicipalityEmitter.subscribe(() => {
      const storedMunicipalityId = localStorage.getItem('municipality');
      if (storedMunicipalityId && this.municipalitySelect) {
        const selected = this.filterData['municipality'].find(m => m.id === storedMunicipalityId);
        this.municipalitySelect.resetAll();
        if (selected) {
          this.municipalitySelect.setSelectedData([selected]);
          this.selectChange({ data: [selected] }, 'municipality');
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.municipalityChangeSubscription) {
      this.municipalityChangeSubscription.unsubscribe();
    }
  }

  selectChange = (event: any, field: string) => {
    this.queryFilter[field] = event.data.map(elem => elem.id);
    if (this.queryFilter[field].length === 0) {
      delete this.queryFilter[field];
      if (field === 'municipality') {
        this.resetFilter();
      }
      if (field === 'district') {
        this.filterData['ilot'] = null;
        this.filterData['lot'] = null;
        delete this.queryFilter['ilot']
        delete this.queryFilter['lot']
        this.ilotSelect?.resetAll();
        this.lotSelect?.resetAll();
        
      }
  
      if (field === 'ilot') {
        this.filterData['lot'] = null;
        delete this.queryFilter['lot']
        this.lotSelect?.resetAll();
      }
    }
  };

  onSelect(event: MatSelectChange, field: string) {
    this.populateFields(event.value, field);
  }

  async populateFields(value: any, field: string) {

    if (!value || !value.id) {
      if (field === 'MUNICIPALITY') {
        this.filterData['district'] = [];
        this.filterData['ilot'] = [];
        this.filterData['lot'] = [];
      } else if (field === 'DISTRICT') {
        this.filterData['ilot'] = [];
        this.filterData['lot'] = [];
      } else if (field === 'ILOT') {
        this.filterData['lot'] = [];
      }
      return;
    }

    if (field === 'MUNICIPALITY') {
      this.districts = await this.categoryService.getSubList('dictionary/municipality/' + value.id + '/district').toPromise();
      if (this.districts)
      this.filterData['district'] = this.districts.map(d => ({ id: d.id, name: d.name })).sort((a, b) => a.name.localeCompare(b.name));
    }
    if (field === 'DISTRICT') {
      this.ilots = await this.categoryService.getSubList('dictionary/district/' + value.id + '/division').toPromise();
      if (this.ilots)
      this.filterData['ilot'] = this.ilots.map(i => ({ id: i.id, name: i.name })).sort((a, b) => a.name.localeCompare(b.name));
    }
    if (field === 'ILOT'){
      this.ilotId = value.id
      const response = await this.propertyTaxService.getLotByIlot(this.ilotId).toPromise()
      if(response?.lot){
        this.filterData['lot'] = response.lot.map(i => ({ id: i, name: i })).sort((a, b) => a.name.localeCompare(b.name));
      } else {
        this.filterData['lot'] = []
      }
    }
  }

  resetFilter() {
    this.filterData
    this.queryFilter = {};
    this.lotSelect?.resetAll();
    this.ilotSelect?.resetAll();
    this.districtSelect?.resetAll();
    this.municipalitySelect?.resetAll();
    this.filterData['district'] = null;
    this.filterData['ilot'] = null;
    this.filterData['lot'] = null;
    this.onReset.emit();
  }

  advancedSearch() {
    this.onFilter.emit(this.queryFilter);
    this.panelOpenState = false;
  }

  setRange(range) {
    this.queryFilter['from'] = range.from;
    this.queryFilter['to'] = range.to;
  }

  async populateDropdowns() {
    const storedMunicipalityId = localStorage.getItem('municipality');
    if (storedMunicipalityId) {
      this.municipality = this.municipalities.find(m => m.id === storedMunicipalityId);
      this.districts = await this.categoryService.getSubList('dictionary/municipality/' + this.municipality.id + '/district').toPromise();
      this.filterData['district'] = this.districts.map(d => ({ id: d.id, name: d.name }));
    }
  }
}
